import { graphql } from '../gql';
import { useMutation } from '@apollo/client';

export const UPSERT_SUBJECTIVITY = graphql(`
  mutation UpsertSubjectivity(
    $quote_uuid: String!
    $subjectivity: SubjectivityInput!
    $has_subjectivity: HasSubjectivityInput!
  ) {
    upsertSubjectivity(
      quoteUuid: $quote_uuid
      subjectivity: $subjectivity
      details: $has_subjectivity
    ) {
      uuid
      type
      name
      description
      afterPolicy
      excess
      order
      primary
      priorToBind
      priorToPolicy
      quote {
        included
        isSatisfied
        waived
        deadline
        uuid
        __typename
      }
      __typename
    }
  }
`);

export function UpsertCustomSubjectivityMutation() {
  const [UpsertSubjectivity, { loading, error, reset }] =
    useMutation(UPSERT_SUBJECTIVITY);

  return {
    UpsertSubjectivity,
    loading,
    error,
    reset,
  };
}
